import React from "react";
import LoginCredentails from "./views/LoginCredentail";
import { LoginCredentailsContextProvider } from "./LoginCredentailView";
import LoginContent from "../../../../constants/contentFile.json";

const LoginCredentail = () => {
  return (
    <LoginCredentailsContextProvider>
      <LoginCredentails textContents={LoginContent.loginPage} />
    </LoginCredentailsContextProvider>
  );
};

export default LoginCredentail;
